import React from "react";
import { useCallback } from "react";
import { removeError } from "common/store/messagesSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  Notification,
  NotificationGroup,
} from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";

export const Messages = () => {
  const errors = useAppSelector((state) => state.common.messages.lastErrors);
  const dispatch = useAppDispatch();
  const handleOnClose = useCallback(
    (index: number) => {
      dispatch(removeError({ index }));
    },
    [dispatch]
  );
  return (
    <div>
      <NotificationGroup
        style={{
          right: 0,
          bottom: 0,
          alignItems: "flex-start",
          flexWrap: "wrap-reverse",
          zIndex: 10003,
        }}
      >
        {errors.map((error, index) => (
          <Fade key={index}>
            <Notification
              key={index}
              type={{ style: "error" }}
              closable
              onClose={() => handleOnClose(index)}
            >
              {error.message}
            </Notification>
          </Fade>
        ))}
      </NotificationGroup>
    </div>
  );
};
